<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">لیست تخفیف های پلکانی</h1>
          <b-row>
            <!-- Search -->
            <b-col cols="12">
              <div
                class="d-flex flex-column flex-md-row align-items-center justify-content-end"
              >
                <b-form-group
                  class="d-inline-block w-100 mr-md-2"
                  label="جستجوی عنوان"
                  label-for="searchCommand"
                >
                  <b-form-input
                    id="searchCommand"
                    v-model="discountFilters.title"
                    class="d-inline-block"
                    placeholder="تخفیف یک ساعت..."
                    @keydown.enter="getAllDiscountsList"
                  />
                </b-form-group>
                <b-form-group
                  class="d-inline-block w-100 mr-md-2"
                  label="مقدار درصد"
                  label-for="percent"
                >
                  <b-form-input
                    id="percent"
                    v-model="discountFilters.percent"
                    placeholder="4"
                    @keydown.enter="getAllDiscountsList"
                  />
                </b-form-group>
                <b-form-group
                  class="d-inline-block w-100 mr-md-2"
                  label="جستجوی دقیقه"
                  label-for="minute"
                >
                  <b-form-input
                    id="minute"
                    v-model="discountFilters.minute"
                    class="d-inline-block"
                    placeholder="45"
                    @keydown.enter="getAllDiscountsList"
                  />
                </b-form-group>
                <b-form-group
                  class="d-inline-block w-100"
                  label="وضعیت تخفیف"
                  label-for="isActive"
                >
                  <b-form-select
                    id="isActive"
                    v-model="discountFilters.isActive"
                    :options="isActiveStatuses"
                  ></b-form-select>
                </b-form-group>
                <b-button
                  variant="primary"
                  class="ml-1 mb-2 mb-md-0"
                  @click="getAllDiscountsList"
                >
                  اعمال
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-table
                ref="refUserListTable"
                class="position-relative"
                :items="discountsList"
                responsive
                :fields="myTableColumns"
                primary-key="id"
                show-empty
                bordered
                striped
                empty-text="موردی موجود نیست!"
              >
                <template #cell(isActive)="data">
                  <b-badge
                    class="font-weight-normal"
                    :variant="data.item.isActive ? 'success' : 'danger'"
                  >
                    {{ data.item.isActive ? "فعال" : "غیر فعال" }}
                  </b-badge>
                </template>
                <template #cell(colorCode)="data">
                  <div
                    class="colorCode"
                    :style="`background-color: ${data.item.colorCode}`"
                  ></div>
                </template>
                <template #cell(minute)="data">
                  {{ data.item.minute }} دقیقه
                </template>
                <template #cell(percent)="data">
                  {{ data.item.percent }}%
                </template>
                <template #cell(actions)="data">
                  <div class="d-flex align-items-center">
                    <b-link
                      :to="`/apps/tiered-discount/${data.item.id}`"
                      class="mr-2"
                    >
                      <feather-icon
                        class="text-primary"
                        icon="EditIcon"
                        size="20"
                      />
                    </b-link>
                    <div
                      style="cursor: pointer"
                      @click="renderDeleteConfirmation(data.item)"
                      v-b-modal.modal-delete
                    >
                      <feather-icon
                        class="text-danger"
                        icon="Trash2Icon"
                        size="20"
                      />
                    </div>
                  </div>
                </template>
              </b-table>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
            >
              <b-pagination
                v-model="discountFilters.pageNumber"
                :total-rows="totalCount"
                :per-page="discountFilters.take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    style="transform: rotate(180deg)"
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      title="حذف تخفیف پلکانی"
      id="modal-delete"
      centered
      ok-title="بله"
      cancelTitle="خیر"
      @ok="deleteADiscount"
    >
      <b-container>
        <span v-if="tempScheduleStepDiscount">
          آیا از حذف کردن تخفیف {{ tempScheduleStepDiscount.title }} با درصد
          {{ tempScheduleStepDiscount.percent }} در دقیقه
          {{ tempScheduleStepDiscount.minute }} اطمینان دارید ؟
        </span>
      </b-container>
    </b-modal>
  </b-overlay>
</template>

<script>
export default {
  mounted() {
    this.getAllDiscountsList();
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllDiscountsList();
      },
    },
  },
  data() {
    return {
      isLoading: false,
      discountsList: null,
      discountFilters: {
        title: null,
        percent: null,
        isActive: null,
        minute: null,
        colorCode: null,
        pageNumber: 1,
        take: 10,
      },
      totalCount: null,
      tempScheduleStepDiscount: null,
      myTableColumns: [
        {
          key: "id",
          label: "شناسه تخفیف",
        },
        {
          key: "title",
          label: "عنوان تخفیف",
        },
        {
          key: "isActive",
          label: "وضعیت تخفیف",
        },
        {
          key: "minute",
          label: "تعداد دقیقه مورد نیاز برای اعمال تخفیف",
        },
        {
          key: "percent",
          label: "درصد تخفیف",
        },
        {
          key: "colorCode",
          label: "رنگ سلول",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
      isActiveStatuses: [
        {
          value: null,
          text: "همه",
        },
        {
          value: true,
          text: "فعال ها",
        },
        {
          value: false,
          text: "غیر‌فعال ها",
        },
      ],
    };
  },
  methods: {
    renderDeleteConfirmation(scheduleStepDiscount) {
      this.tempScheduleStepDiscount = JSON.parse(
        JSON.stringify(scheduleStepDiscount)
      );
    },
    async deleteADiscount() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteAScheduleStepDiscount = new DeleteAScheduleStepDiscount(
          _this
        );
        deleteAScheduleStepDiscount.setRequestParam({
          id: _this.tempScheduleStepDiscount.id,
        });
        await deleteAScheduleStepDiscount.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "Trash2Icon",
                variant: "success",
                text: "تخفیف با موفقیت حذف شد.",
              },
            });
            _this.getAllDiscountsList();
            _this.tempScheduleStepDiscount = null;
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "Trash2Icon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllDiscountsList() {
      try {
        let qParams = {
          take: this.discountFilters.take,
          pageNumber: this.discountFilters.pageNumber,
        };
        // Check for filters
        // Sorry for this part :|
        // This is hidious
        if (this.discountFilters.title && this.discountFilters.title != "") {
          qParams["title"] = this.discountFilters.title;
        }
        if (
          this.discountFilters.percent &&
          this.discountFilters.percent != ""
        ) {
          qParams["percent"] = this.discountFilters.percent;
        }
        if (this.discountFilters.isActive != null) {
          qParams["isActive"] = this.discountFilters.isActive;
        }
        if (this.discountFilters.minute) {
          qParams["minute"] = this.discountFilters.minute;
        }
        if (this.discountFilters.colorCode) {
          qParams["colorCode"] = this.discountFilters.colorCode;
        }

        this.isLoading = true;
        let _this = this;
        let getAllDiscounts = new GetAllScheduleStepDiscounts(_this);
        getAllDiscounts.setRequestParamDataObj(qParams);
        await getAllDiscounts.fetch((res) => {
          _this.discountsList = res.data;
          _this.totalCount = res.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    pageNumber() {
      return this.discountFilters.pageNumber;
    },
  },
  components: {
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BInputGroup,
  },
};
import {
  GetAllScheduleStepDiscounts,
  DeleteAScheduleStepDiscount,
} from "@/libs/Api/ScheduleStepDiscount";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BContainer,
  BCard,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BInputGroup,
} from "bootstrap-vue";
</script>
<style scoped>
.colorCode {
  width: 4rem;
  height: 1.5rem;
  border: 1px solid #333333;
}
</style>
